// extracted by mini-css-extract-plugin
module.exports = {"topContent":"TopContent_topContent__1u3hy","title":"TopContent_title__2Vr2R"};